/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import AnimatedButton from '../../components/Button';
import ThreeDotsBlackLoader from '../../components/LoadingDots/ThreeDotsBlack';
import ApplicationContext from '../../context/ApplicationContext';
import { checkKeysInArray, handleValidation } from '../../helpers/CommonFunctions';
import RequiredField from '../../components/RequiredField';
import Label from '../../components/Label';
import TypeDatePicker from '../../components/TypeDatePicker';
import moment from 'moment';
import ErrorMessage from '../../components/ErrorMessageDisplay';
import { dataService } from '../../services/data.service';
import InsuranceHeader from './InsuranceHeader';
import SearchSelectOnType from '../../components/SearchSelectOnType';
import { OcrKeys } from '../../helpers/OcrKeys';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import { cdnURL } from '../../config';
import BackButton from '../../components/Button/BackButton';
import NextButton from '../../components/Button/NextButton';
import { insuranceLanguageContent } from './InsuranceLanguageContent';
import { requiredLanguageContent } from '../../components/RequiredField/requiredLanguageContent';
import { backNextLanguageContent } from '../../components/Button/backNextLanguageContent';
import { identificationLanguageContent } from '../IdentityDocument/IdentificationLanguageContent';

function InsuranceDetails() {
    const { handlePage, insuranceIndex, insurances, sessionData, insurancePreference, setLoading, selectedLanguage } = useContext(ApplicationContext);
    const [insuranceCarrier, setInsuranceCarrier] = useState('');
    const [policyHolderName, setPolicyHolderName] = useState('');
    const [policyNumber, setPolicyNumber] = useState('');
    const [date,setDate]=useState('');
    const [month,setMonth]=useState('');
    const [year,setYear]=useState('');
    const [loader, setLoader] = useState('');
    const [submitSelected, setSubmitSelected] = useState(false);
    const [dateError, setDateError] = useState('');
    const [pageLoading, setPageLoading] = useState(true);

    /**
     * The `changeHandler` function is used to handle changes in input fields and update the
     * corresponding state variables.
     */
    const changeHandler=(e)=>{
        let { id, value }=e.target;
        setDateError("");
        value = value.replace(/[A-Za-z\s]/g, "");
        switch (id) {
        case "digit-1":
            setDate(value);
            break;
        case "digit-2":
            setMonth(value);
            break;
        case "digit-3":
            setYear(value);
            break;
        default:
            break;
        }
    }

    /**
     * The handleSubmit function checks if a given date is valid and not in the past, and if so, it
     * proceeds to the next page.
     */
    const handleSubmit = (event) => {
        let dateString = `${month}/${date}/${year}`;
        if(!moment(dateString, 'MM/DD/YYYY', true).isValid()) {
            setDateError('Invalid date format')
        } else if(moment().isAfter(moment(dateString, 'MM/DD/YYYY'))) {
            setDateError('Expiration date cannot precede the current date');
        } else {
            setLoader(event);
            const payload = {
                "carrier": insuranceCarrier.trim(),
                "policy_holder_name": policyHolderName.trim(),
                "mandatory_id": policyNumber.trim(),
                "plan_expiry_date": moment(dateString, 'MM/DD/YYYY').valueOf(),
                "upload_type_front": insurances[insuranceIndex].upload_type_front,
                "upload_type_back": insurances[insuranceIndex].upload_type_back,
                "process_ocr": false
            }
            dataService.updateInsuranceData(sessionStorage.getItem('session'), payload, insurances[insuranceIndex]._id).then((res) => {
                if(res.error === false) {
                    setLoader('');
                    if(event === 'add') {
                        setLoading(true);
                        handlePage('upload_insurance_choice', 'upload_insurance_images', insuranceIndex + 1, sessionData['review'] === 'previous' ? 'previous' : '')
                    } else {
                        if(insuranceIndex === insurances.length - 1) {
                            setLoading(true);
                            // I need to add a condition here for when opted out
                            if(sessionData['review'] === 'previous' || sessionData?.patient_details?.is_opt_out) {
                                handlePage('review', '', '', '')
                            } else {
                                handlePage(sessionData.documents_count > 0 ? 'documents' : 'review', '', '', sessionData['review'] === 'previous' ? 'previous' : '', undefined, undefined, sessionData.document_session)
                            } 
                        } else {
                            setLoading(true);
                            handlePage('upload_insurance_choice', 'upload_insurance_images', insuranceIndex + 1, sessionData['review'] === 'previous' ? 'previous' : '')
                        }
                    }
                }
            })
        } 
    }

    const handleBackNavigation = () => {
        if(insurances[insuranceIndex].upload_type_front === 'upload'){
            handlePage('upload_insurance_images', '','', sessionData.insurance_index)
        } else {
            handlePage('take_insurance_back_image', '','', sessionData.insurance_index);
        }
    }

    function handleProcessOcr(image) {
        let result = ''
        const payload = {
            key: image
        }
        dataService.processOcr(sessionStorage.getItem('session'), payload).then((res) => {
            if(res.error === false) {
                setInsuranceCarrier(res.data.layouts[0] || '');
                ['member_name', 'member_id', 'expiry_date'].map((item) => {
                    switch(item) {
                    case 'member_id': const result = checkKeysInArray(res.data, OcrKeys['member_id']);
                        if(result) {
                            setPolicyNumber(result)
                        }
                        break
                    case 'expiry_date': const result1 = checkKeysInArray(res.data, OcrKeys['expiry_date']);
                        if(result1) {
                            let dateString = moment(result1).format('MM/DD/YYYY');
                            if(dateString !== 'Invalid date') {
                                dateString = dateString.split('/');
                                setMonth(dateString[0] || '');
                                setDate(dateString[1] || '');
                                setYear(dateString[2] ||  '');
                            }
                        }
                        break
                    case 'member_name': 
                        if(insurancePreference?.is_policy_holder !== "Yes") {
                            const result2 = checkKeysInArray(res.data, OcrKeys['member_name']);
                            if(result2) {
                                setPolicyHolderName(result2)
                            }
                        }
                        break

                    }
                    setPageLoading(false);
                })
            } else {
                setPageLoading(false);
            }
        })
    }

    useEffect(() => {
        if(insurancePreference.is_insurance_exists === "No") {
            handlePage('insurance', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
        } else {
            if(insurancePreference?.is_policy_holder === "Yes" && !insurances[insuranceIndex]?.policy_holder_name) {
                setPolicyHolderName(sessionData.patient_details.first_name + ' ' + sessionData.patient_details.last_name)
            } else {
                setPolicyHolderName((insurances[insuranceIndex].policy_holder_name));
            }
        }
    }, [insurancePreference])

    useEffect(() => {
        if(insurances.length > 0 && insuranceIndex !== '') {
            if(insurances[insuranceIndex]?.process_ocr === true) {
                handleProcessOcr(insurances[insuranceIndex].insurance_front_image);
            } else {
                setPolicyNumber(insurances[insuranceIndex].mandatory_id || '');
                setInsuranceCarrier(insurances[insuranceIndex]?.carrier || '');
                let dateString = moment(insurances[insuranceIndex]?.plan_expiry_date || '').format('MM/DD/YYYY');
                if(dateString !== "Invalid date") {
                    dateString = dateString.split('/');
                    setMonth(dateString[0]);
                    setDate(dateString[1]);
                    setYear(dateString[2]);
                }
                setPageLoading(false);
            }
        } else {
            setPageLoading(false);
        }
    }, [insurances, insuranceIndex])

    return (
        <AnimatedPageFade className={`flex flex-col ${pageLoading ? '' : 'justify-between'} relative h-welcome gradient-bg rounded-[16px] overflow-auto`}>
            <InsuranceHeader />
            <div className='p-[8px] overflow-x-hidden overflow-y-auto options-height Form-scroll'>
                {insuranceLanguageContent['insurance-detail-info'][selectedLanguage]}
                <div className={`mt-[12px] ${selectedLanguage == 'ar' ? 'dir-rtl' : ''}`}>
                    <div className='relative'>
                        <Label labelID="insurance_carrier" disabled={false} labelName={insuranceLanguageContent['insurance-carrier'][selectedLanguage]} isMandatory={true} />
                        {pageLoading
                            ?  <div className='animate-pulse h-[40px] mt-1 w-full bg-slate-300 rounded' />
                            :<SearchSelectOnType selectedData={insuranceCarrier} setSelectedData={setInsuranceCarrier} />}
                    </div>
                    <div className='relative mt-[15px] w-full'>
                        <Label labelID="policy_holder_name" disabled={false} labelName={insuranceLanguageContent['policy-holder-name'][selectedLanguage]} isMandatory={true} />
                        {pageLoading
                            ?  <div className='animate-pulse h-[40px] mt-1 w-full bg-slate-300 rounded' />
                            :
                            <input data-testid="policy_holder_name" maxLength={100}
                                autoComplete="off" type="text" id="policy_holder_name" value={policyHolderName} onChange={(e) => {setSubmitSelected(false); setPolicyHolderName(e.target.value)}}
                                className={`w-full mt-1 bg-[#F1F2F2] border ${submitSelected && policyHolderName.trim() === '' ? 'border-[#B51803]' : 'border-[#797979]'} 
                        py-[10px]  px-[12px] rounded h-[40px] font-normal text-[#333] text-sm  outline-0  placeholder:text-sm placeholder:text-[#797979]`} placeholder={insuranceLanguageContent['Enter policy holder name'][selectedLanguage]} />
                        }
                    </div>
                    <div className='relative mt-[15px] w-full'>
                        <Label labelID="policy_number" disabled={false} labelName={insuranceLanguageContent['member-id'][selectedLanguage]} isMandatory={true} />
                        {pageLoading
                            ?  <div className='animate-pulse h-[40px] mt-1 w-full bg-slate-300 rounded' />
                            :
                            <input data-testid="policy_number" maxLength={30}
                                autoComplete="off" type="text" id="policy_number" value={policyNumber} onChange={(e) => {setSubmitSelected(false); setPolicyNumber(e.target.value)}}
                                className={`w-full mt-1 bg-[#F1F2F2] border ${submitSelected && policyNumber.trim() === '' ? 'border-[#B51803]' : 'border-[#797979]'} 
                        py-[10px]  px-[12px] rounded h-[40px] font-normal text-[#333] text-sm  outline-0  placeholder:text-sm placeholder:text-[#797979]`} placeholder={identificationLanguageContent['Enter card number'][selectedLanguage]} />
                        }
                    </div>
                    <div className='relative mt-[15px] w-full'>
                        <Label labelID="expiry_date" disabled={false} labelName={insuranceLanguageContent['expiration-date'][selectedLanguage]} isMandatory={true} />
                        {pageLoading
                            ?  <div className='animate-pulse h-[40px] mt-1 w-full bg-slate-300 rounded' />
                            : <TypeDatePicker changeHandler={changeHandler} dateError={dateError}  date={date} month={month} year={year} />
                        }
                    </div>
                    <ErrorMessage text={dateError} />
                    <span className='flex mt-[15px]'>
                        <RequiredField />
                        <p className='text-gray text-sm font-normal ml-2'> {requiredLanguageContent['required'][selectedLanguage]}</p>
                    </span>
                    {!pageLoading && <div className='mt-[24px] py-4'>
                        <div>
                            <p className='font-semibold text-sm text-[#333]'>{insuranceLanguageContent['front'][selectedLanguage]}</p>
                            <div className='mt-3 max-h-[300px]'>
                                <AnimatedImage url={`https://${cdnURL}/${insurances[insuranceIndex]?.insurance_front_image}`} className="object-contain max-h-[280px] mx-auto" alt="insurance-front" />
                            </div>
                        </div>
                        <div className='mt-[12px]'>
                            <p className='font-semibold text-sm text-[#333]'>{backNextLanguageContent['back'][selectedLanguage]}</p>
                            <div className='mt-3 max-h-[300px]'>
                                <AnimatedImage url={`https://${cdnURL}/${insurances[insuranceIndex]?.insurance_back_image}`} className="object-contain max-h-[280px] mx-auto" alt="insurance-back" />
                            </div>
                        </div>
                    </div>}
                    {(!pageLoading && insurancePreference['is_multiple_insurance_exists'] === "Yes" && insuranceIndex > 0) &&
                    <AnimatedButton handleClick={() => handleSubmit('add')} disabled={!handleValidation({insuranceCarrier, policyHolderName, policyNumber, date, month, year}) || loader === 'add' || loader === 'submit'}
                        id="add_more_button" 
                        className={`text-gray text-[16px] 
                    font-semibold text-gray bg-[#F2F2F2] w-[200px] h-[40px] justify-center fold-normal-text mx-auto my-[10px]`}>
                        <p className={`w-[60%] ${loader === 'add' ? 'flex justify-center' : ''}`}>{loader === 'add' ? <ThreeDotsBlackLoader /> : backNextLanguageContent['add-more'][selectedLanguage]}</p>
                        {loader === 'add' ? '' : <img src="/images/Add.svg" alt="add" className='flex justify-start h-[1.7em]' />}
                    </AnimatedButton>}
                </div>
            </div>
            {!pageLoading &&
            <div className='flex mb-[24px] justify-between gap-[12px] mx-[16px] w-auto fold-gap pt-[20px] '>
                {(insurancePreference['is_multiple_insurance_exists'] === "Yes" && insuranceIndex === 0) &&
                <>
                    <BackButton disabled={loader === 'add' || loader === 'submit'} handleClick={() => handleBackNavigation()} backType="previous" />
                    <AnimatedButton handleClick={() => handleSubmit('add')}
                        id="add_more_button" disabled={!handleValidation({insuranceCarrier, policyHolderName, policyNumber, date, month, year}) || loader === 'add'} 
                        className={`font-semibold text-gray w-[200px] h-[40px] ${loader ? '' : 'pl-[24px]'} bg-[#F2F2F2] fold-normal-text text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-center`}>
                        {loader ? <ThreeDotsBlackLoader /> : backNextLanguageContent['add-more'][selectedLanguage]}
                        {!loader && <img src="/images/Add.svg" alt="next" className='ml-[20px] w-[1.7em] h-[1.7em]' />}
                    </AnimatedButton>
                </>
                }
                {(insurancePreference['is_multiple_insurance_exists'] === "No") &&
                <>
                    <BackButton disabled={loader === 'add' || loader === 'submit'} handleClick={() => handleBackNavigation()} backType="previous" />
                    <NextButton disabled={!handleValidation({insuranceCarrier, policyHolderName, policyNumber, date, month, year}) || loader === 'submit'} handleClick={() => handleSubmit('submit')} loader={loader} />
                </>
                }
                {(insurancePreference['is_multiple_insurance_exists'] === "Yes" && insuranceIndex > 0) &&
                <>
                    <BackButton disabled={loader === 'add' || loader === 'submit'} handleClick={() => handleBackNavigation()} backType="previous" />
                    <NextButton disabled={!handleValidation({insuranceCarrier, policyHolderName, policyNumber, date, month, year}) || loader === 'submit'} handleClick={() => handleSubmit('submit')} loader={loader} />
                </>
                }
            </div>
            }
        </AnimatedPageFade>
    );
}

export default InsuranceDetails;